export const KLARO_FEATURES = Object.freeze([
  {
    id: 'goods-receipt',
    title: 'Carica merce',
    menuLabel: 'Carica merce',
    description: 'Registra materie prime e ingredienti',
    route: '/carica-merce',
    icon: 'goodsReceipt',
    menuIcon: 'goodsReceiptMenu',
    feature: 'inventory.receive',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'production',
    title: 'Produzione',
    menuLabel: 'Produzione',
    description: 'Gestisci le lavorazioni e le ricette',
    route: '/batch',
    icon: 'production',
    menuIcon: 'productionMenu',
    feature: 'production.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'warehouse',
    title: 'Magazzino',
    menuLabel: 'Magazzino',
    description: 'Monitora lotti e giacenze',
    route: '/magazzino',
    icon: 'warehouse',
    menuIcon: 'warehouseMenu',
    feature: 'inventory.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'recipes',
    title: 'Ricette',
    menuLabel: 'Ricette',
    description: 'Crea e gestisci le ricette',
    route: '/ricette',
    icon: 'recipes',
    menuIcon: 'recipesMenu',
    feature: 'recipes.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'expiry-calendar',
    title: 'Scadenze',
    menuLabel: 'Scadenze',
    description: 'Monitora le scadenze e ricevi avvisi',
    route: '/scadenzario',
    icon: 'expiry',
    menuIcon: 'expiryMenu',
    feature: 'expiry.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'labels',
    title: 'Etichette',
    menuLabel: 'Etichette',
    description: 'Crea e stampa le etichette',
    route: '/etichette',
    icon: 'labels',
    menuIcon: 'labelsMenu',
    feature: 'labels.print',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'GESTIONE',
  },
  {
    id: 'traceability',
    title: 'Tracciabilità',
    menuLabel: 'Tracciabilità',
    description: 'Segui il percorso dei tuoi prodotti',
    route: '/registro?tab=traceability',
    icon: 'traceability',
    menuIcon: 'traceabilityMenu',
    feature: 'traceability.advanced',
    dashboard: true,
    defaultVisible: true,
    mobileWide: true,
    menuSection: null,
    activeTab: 'traceability',
  },
  {
    id: 'haccp-register',
    title: 'Registro HACCP',
    menuLabel: 'Registro HACCP',
    description: 'Consulta attività, audit e registrazioni',
    route: '/registro',
    icon: 'checklistAudit',
    menuIcon: 'haccpRegisterMenu',
    feature: 'haccp.register',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'HACCP',
    activeTab: 'activity',
    matchAllTabs: true,
  },
  {
    id: 'ingredients',
    title: 'Ingredienti e prodotti',
    menuLabel: 'Ingredienti e prodotti',
    description: 'Gestisci materie prime e prodotti',
    route: '/ingredienti',
    icon: 'ingredients',
    menuIcon: 'ingredientsMenu',
    feature: 'catalog.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'GESTIONE',
  },
  {
    id: 'suppliers',
    title: 'Fornitori',
    menuLabel: 'Fornitori',
    description: 'Gestisci i tuoi fornitori',
    route: '/fornitori',
    icon: 'suppliers',
    menuIcon: 'suppliersMenu',
    feature: 'catalog.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'GESTIONE',
  },
  {
    id: 'allergens',
    title: 'Allergeni',
    menuLabel: 'Allergeni',
    description: 'Gestisci allergeni e associazioni',
    route: '/allergeni',
    icon: 'allergens',
    menuIcon: 'allergensMenu',
    feature: 'catalog.manage',
    dashboard: true,
    defaultVisible: true,
    menuSection: 'GESTIONE',
  },
  {
    id: 'options',
    title: 'Impostazioni',
    menuLabel: 'Impostazioni',
    description: 'Personalizza il tuo ambiente e le preferenze',
    route: '/opzioni',
    icon: 'settingsSliders',
    menuIcon: 'settings',
    feature: null,
    dashboard: true,
    defaultVisible: true,
    menuSection: 'SISTEMA',
  },
]);

export const KLARO_EXTRA_NAV_ITEMS = Object.freeze([
  {
    id: 'dashboard',
    menuLabel: 'Home',
    route: '/dashboard',
    menuIcon: 'home',
    feature: 'dashboard.view',
    menuSection: 'OPERATIVITÀ',
  },
  {
    id: 'haccp-reports',
    menuLabel: 'Report HACCP',
    route: '/registro?tab=reports',
    menuIcon: 'reportMenu',
    feature: 'haccp.reports',
    menuSection: null,
    activeTab: 'reports',
  },
]);

const SECTION_ORDER = ['OPERATIVITÀ', 'GESTIONE', 'HACCP', 'SISTEMA'];

export const KLARO_NAV_SECTIONS = SECTION_ORDER.map((label) => ({
  label,
  items: [...KLARO_EXTRA_NAV_ITEMS, ...KLARO_FEATURES]
    .filter((item) => item.menuSection === label)
    .sort((a, b) => {
      if (label === 'OPERATIVITÀ') {
        const order = ['dashboard', 'goods-receipt', 'production', 'warehouse', 'recipes', 'expiry-calendar'];
        return order.indexOf(a.id) - order.indexOf(b.id);
      }
      if (label === 'GESTIONE') {
        const order = ['ingredients', 'suppliers', 'allergens', 'labels'];
        return order.indexOf(a.id) - order.indexOf(b.id);
      }
      if (label === 'HACCP') {
        const order = ['haccp-register', 'traceability', 'haccp-reports'];
        return order.indexOf(a.id) - order.indexOf(b.id);
      }
      return 0;
    }),
}));
